import { get } from 'lodash-es';

import { STATUS_LOADING, STATUS_SUCCESS, STATUS_ERROR } from 'store/status';
import { CLEAR_ORDERS, GET_ORDERS } from 'modules/v2/store/constants';
import { orders as initialState } from 'modules/v2/store/reducers/initialState';

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_ORDERS}_REQUESTED`: {
      return { ...state, data: null, status: STATUS_LOADING };
    }

    case `${GET_ORDERS}_SUCCEEDED`: {
      const data = get(action, ['payload'], null);

      return {
        ...state,
        status: STATUS_SUCCESS,
        data,
      };
    }

    case `${GET_ORDERS}_FAILED`: {
      return { ...state, status: STATUS_ERROR };
    }

    case CLEAR_ORDERS: {
      return { ...initialState };
    }

    default:
      return state;
  }
};

export default reducer;
